<form [formGroup]="form" autocomplete="off" (ngSubmit)="onSubmit()" novalidate>
  <form-group-context label="Version" formControlName="version">
    <form-group-simple name="version" placeholder="Version"></form-group-simple>
  </form-group-context>

  <form-group-context label="Store" formControlName="store">
    <form-group-select entity="store"
                       bindLabel="name"
                       [searchable]="true"
                       [storeQuery]="null"
                       bindValue="id"
                       placeholder="Store"></form-group-select>
  </form-group-context>

  <form-group-context label="Supported" formControlName="supported">
    <form-group-simple name="supported" placeholder="Supported"></form-group-simple>
  </form-group-context>


  <form-group-context label="Deprecated" formControlName="isDeprecated">
    <form-group-simple type="checkbox" name="isDeprecated"></form-group-simple>
  </form-group-context>

  <form-group-context label="iOS"
                      *ngIf="form.get('appleAddressable')"
                      formControlName="appleAddressable">
    <form-group-files [accepted]="acceptedFiles" [single]="true" [config]="storeDropzoneAppleConfig"></form-group-files>
  </form-group-context>

  <form-group-context label="Android"
                      *ngIf="form.get('googleAddressable')"
                      formControlName="googleAddressable">
    <form-group-files [accepted]="acceptedFiles" [single]="true" [config]="storeDropzoneGoogleConfig"></form-group-files>
  </form-group-context>

  <form-group-context label="Actions" [hidden]="actions.isEmpty" #actions>
    <ng-content select="[form][actions]"></ng-content>
  </form-group-context>

  <div class="mt-3">
    <ng-content></ng-content>
  </div>
</form>
